import { Container, Card, Button, Row, Col, ProgressBar } from "react-bootstrap";
import { getCart, removeFromCart, updateCartQuantity } from "../utils/functionMenu";
import { useState, useEffect } from "react";
import { useCart } from "../utils/CartContext";
import { getAuth } from "firebase/auth";
import { addUserAction, listenToUserCart } from "../utils/functionFirebase";
import { toast } from 'react-toastify';

export default function Cart() {
  const [cart, setCart] = useState([]);
  const { refreshCartCount } = useCart();
  const [showTableInput, setShowTableInput] = useState(false);
  const [tableNumber, setTableNumber] = useState("");
  const [tableError, setTableError] = useState("");

  useEffect(() => {
    const auth = getAuth();
    const user = auth.currentUser;
    let unsubscribe;
    if (user) {
      // استمع للسلة اللحظية من Firestore
      unsubscribe = listenToUserCart(user.uid, (result) => {
        if (result.success && Array.isArray(result.cart)) {
          setCart(result.cart);
        } else {
          setCart([]);
        }
      });
    } else {
      // للزوار: استخدم localStorage
      const fetchCart = async () => {
        const c = await getCart();
        setCart(c);
      };
      fetchCart();
      const handleStorage = async () => {
        const c = await getCart();
        setCart(c);
      };
      window.addEventListener("storage", handleStorage);
      return () => window.removeEventListener("storage", handleStorage);
    }
    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, []);

  const handleRemove = async (id) => {
    await removeFromCart(id, cart); // مرر نسخة السلة الحالية
    // لا داعي لجلب السلة هنا، سيتم التحديث تلقائياً عبر الاستماع اللحظي
  };

  const maxQuantity = cart.length > 0 ? Math.max(...cart.map(item => item.quantity), 5) : 5;
  const total = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);

  const handleShowTableInput = () => {
    setShowTableInput(true);
  };

  const handleCheckout = async () => {
    if (!tableNumber.trim()) {
      setTableError("يرجى إدخال رقم الطاولة.");
      return;
    }
    setTableError("");
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) {
      toast.error("يرجى تسجيل الدخول أولاً لإتمام الطلب.");
      return;
    }
    const action = {
      type: "order",
      date: new Date().toISOString(),
      items: cart, // مصفوفة المنتجات المطلوبة
      total: total, // المجموع الكلي
      tableNumber: tableNumber // رقم الطاولة
    };
    // خزّن الطلب فقط في actions الخاصة بالمستخدم في authentact
    const result = await addUserAction(action);
    if (result.success) {
      toast.success("تم حفظ طلبك بنجاح!");
      // امسح السلة من Firestore أو localStorage حسب حالة المستخدم
      if (user) {
        const { saveUserCart } = await import("../utils/functionFirebase");
        await saveUserCart(user.uid, []);
      } else {
        localStorage.removeItem("cart");
      }
      setCart([]);
      refreshCartCount();
      setShowTableInput(false);
      setTableNumber("");
    } else {
      toast.error("حدث خطأ أثناء حفظ الطلب: " + (result.error || ""));
    }
  };

  return (
    <Container className="py-5">
      <h2 className="mb-4 text-center">سلة المشتريات</h2>
      {cart.length === 0 ? (
        <h5 className="text-center">السلة فارغة</h5>
      ) : (
        <>
          <Row className="gy-4">
          {cart.map((item, idx) => (
  <Col xs={12} key={item.id || idx}>
    <Card className="flex-row align-items-center shadow-sm p-2" style={{ minHeight: 110 }}>
      <Card.Img
        src={item.img || 'https://via.placeholder.com/80'}
        alt={item.name || 'منتج'}
        style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 12, marginLeft: 16 }}
        onError={e => { e.target.onerror = null; e.target.src = 'https://via.placeholder.com/80'; }}
      />
      <Card.Body className="d-flex flex-column justify-content-between">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <Card.Title className="mb-1">{item.name || 'منتج غير معروف'}</Card.Title>
            <div className="text-muted" style={{ fontSize: 14 }}>
              السعر: {item.price ? `${item.price} د.أ` : 'غير متوفر'}
            </div>
          </div>
          <Button variant="danger" size="sm" style={{ minWidth: 60 }} onClick={() => handleRemove(item.id)}>
            حذف
          </Button>
        </div>
        <div className="mt-2">
          <div className="d-flex justify-content-between align-items-center mb-1">
            <span style={{ fontSize: 13 }}>الكمية:
              <Button
                variant="light"
                size="sm"
                className="mx-1 border"
                onClick={async () => {
                  if (item.quantity > 1) await updateCartQuantity(item.id, item.quantity - 1, cart);
                }}
                disabled={item.quantity <= 1}
              >
                -
              </Button>
              <input
                type="number"
                min="1"
                value={item.quantity || 1}
                onChange={async (e) => {
                  let val = parseInt(e.target.value) || 1;
                  if (val < 1) val = 1;
                  await updateCartQuantity(item.id, val, cart);
                }}
                style={{ width: 50, textAlign: 'center', margin: '0 4px' }}
              />
              <Button
                variant="light"
                size="sm"
                className="mx-1 border"
                onClick={async () => await updateCartQuantity(item.id, item.quantity + 1, cart)}
              >
                +
              </Button>
            </span>
            <span className="fw-bold">{item.price && item.quantity ? item.price * item.quantity : ''} د.أ</span>
          </div>
        </div>
      </Card.Body>
    </Card>
  </Col>
))}
          </Row>
          <Row className="justify-content-center mt-5">
            <Col md={6} lg={4}>
              <Card className="text-center shadow-lg border-0" style={{ borderRadius: 18 }}>
                <Card.Body>
                  <Card.Title className="mb-3" style={{ fontWeight: 700, fontSize: 22 }}>
                    المجموع الكلي
                  </Card.Title>
                  <Card.Text className="fs-3 fw-bold text-success">{total} د.أ</Card.Text>
                  {showTableInput ? (
                    <div className="mb-3">
                      <input
                        type="number"
                        min="1"
                        className="form-control mb-2"
                        placeholder="أدخل رقم الطاولة"
                        value={tableNumber}
                        onChange={e => setTableNumber(e.target.value)}
                        style={{textAlign:'center'}}
                      />
                      {tableError && <div className="text-danger mb-2">{tableError}</div>}
                      <Button variant="success" size="lg" style={{ borderRadius: 20 }} onClick={handleCheckout} disabled={cart.length === 0}>
                        تأكيد الطلب
                      </Button>
                    </div>
                  ) : (
                    <Button variant="success" size="lg" style={{ borderRadius: 20 }} onClick={handleShowTableInput} disabled={cart.length === 0}>
                      إتمام الشراء
                    </Button>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
}